import React from "react";
import "./category.css";
import { useNavigate } from "react-router-dom";

const categories = [
  { name: "Cafe",               icon: "☕", bg: "linear-gradient(135deg,#93C5FD,#3B82F6)" },
  { name: "Restaurant",         icon: "🍽️", bg: "linear-gradient(135deg,#FCA5A5,#EF4444)" },
  { name: "Grocery",            icon: "🛒", bg: "linear-gradient(135deg,#A5B4FC,#6366F1)" },
  { name: "Saloon",             icon: "✂️", bg: "linear-gradient(135deg,#6EE7B7,#10B981)" },
  { name: "Fruits & Vegetables",icon: "🥦", bg: "linear-gradient(135deg,#86EFAC,#16A34A)" },
  { name: "Electronics",        icon: "📱", bg: "linear-gradient(135deg,#7DD3FC,#0284C7)" },
  { name: "Hardware",           icon: "🔧", bg: "linear-gradient(135deg,#FCD34D,#D97706)" },
  { name: "Car & Bike",         icon: "🚗", bg: "linear-gradient(135deg,#CBD5E1,#64748B)" },
  { name: "Autoparts",          icon: "⚙️", bg: "linear-gradient(135deg,#D1D5DB,#6B7280)" },
  { name: "Medical",            icon: "💊", bg: "linear-gradient(135deg,#FCA5A5,#EF4444)" },
  { name: "Hospitals",          icon: "🏥", bg: "linear-gradient(135deg,#FCA5A5,#DC2626)" },
  { name: "Gym",                icon: "🏋️", bg: "linear-gradient(135deg,#C4B5FD,#7C3AED)" },
  { name: "Individual Services",icon: "🤝", bg: "linear-gradient(135deg,#6EE7B7,#059669)" },
  { name: "Entertainment",      icon: "🎬", bg: "linear-gradient(135deg,#FDA4AF,#E11D48)" },
  { name: "Footwear",           icon: "👟", bg: "linear-gradient(135deg,#FDBA74,#F97316)" },
  { name: "Textiles",           icon: "👗", bg: "linear-gradient(135deg,#F9A8D4,#DB2777)" },
  { name: "Others",             icon: "🏪", bg: "linear-gradient(135deg,#93C5FD,#1D4ED8)" },
];

const Category = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    navigate("/userdashboard/restaurants", { state: { category } });
  };

  return (
    <div className="category-container">
      <div className="category-header">
        <h2 className="category-title">All Categories</h2>
        <p className="category-subtitle">Choose a category to browse local shops</p>
      </div>

      <div className="category-grid">
        {/* Malls card — always first */}
        <div className="category-card category-card-malls" onClick={() => navigate('/userdashboard/malls')}>
          <div className="cat-icon-circle" style={{ background: "linear-gradient(135deg,#FDBA74,#F97316)" }}>
            <span className="category-icon">🏬</span>
          </div>
          <p>Malls</p>
        </div>

        {categories.map((cat, index) => (
          <div className="category-card" key={index} onClick={() => handleCategoryClick(cat.name)}>
            <div className="cat-icon-circle" style={{ background: cat.bg }}>
              <span className="category-icon">{cat.icon}</span>
            </div>
            <p>{cat.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Category;
